import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Breadcrumbs } from "../breadcrumbs";
import { CreateNotificationForm } from "../forms/create-notification-form";
import { NotificationsTable } from "../tables/notifications-table";
import { Button } from "../ui/button";
import {
	Sheet,
	SheetContent,
	SheetHeader,
	SheetTitle,
	SheetTrigger,
} from "../ui/sheet";

export function PushNotifications() {
	const [open, setOpen] = useState(false);

	return (
		<div className="space-y-2">
			<Breadcrumbs />
			<Sheet open={open} onOpenChange={setOpen}>
				<div className="flex flex-col">
					<div className="flex justify-between">
						<h2>Notification Center</h2>
						<SheetTrigger render={<Button />}>Create Notification</SheetTrigger>
						<SheetContent className="overflow-y-auto">
							<SheetHeader>
								<SheetTitle>Create A New Notification</SheetTitle>
							</SheetHeader>
							<div className="px-4">
								<CreateNotificationForm onComplete={() => setOpen(false)} />
							</div>
						</SheetContent>
					</div>
					<NotificationsTable />
				</div>
			</Sheet>
		</div>
	);
}
